import React, { useState } from 'react'
import adminStyles from './adminStyles.module.css'
import axios from 'axios'
const AddDoctor = () => {
  const[trtname,setTrtname]=useState("");
  const[dname,setDname]=useState("")
  const[dexperience,setDexperience]=useState("")
  const[dqualification,setDqualification]=useState("")
  const[whospitalw,setWhospitalw]=useState("")
  const[location,setLocation]=useState("")
  const[dphone,setDphone]=useState("")
  
   const addServiceData=(e)=>{
    e.preventDefault();
    axios.post(`https://backendsurgylife-1.onrender.com/doctor`,{
      trtname,dname,dexperience,dqualification,whospitalw,location,dphone,
    })
    .then((res)=>{
      alert("Doctor Booked Successfully")
      setTrtname("");
      setDname("");
      setDexperience("");
      setDqualification("");
      setWhospitalw("");
      setLocation("");
      setDphone("");
      
      
    })
    .catch((err)=>{
      alert("Error booking doctor")
    })
  }
  return (
    
  <main>
       
             
                    <section>
                    <div className='container'>
                      <div className='row'>
                        <div className='col-md-12 mx-auto'>
                        <form className={adminStyles.bx_shadow} onSubmit={addServiceData}>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='trtname'
                                 className='form-control'
                                 placeholder='Treatment Name'
                                 value={trtname}
                                 onChange={(e)=>setTrtname(e.target.value)}
                                 />
                              </div>
                            </div>

                             <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='dname'
                                 className='form-control'
                                 placeholder='Doctor Name'
                                 value={dname}
                                 onChange={(e)=>setDname(e.target.value)}
                                 />
                              </div>
                            </div>

                          </div>

                              <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='dexperience'
                                 className='form-control'
                                 placeholder='Doctor Experience'
                                 value={dexperience}
                                 onChange={(e)=>setDexperience(e.target.value)}
                                 />
                              </div>
                            </div>

                             <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='dqualification'
                                 className='form-control'
                                 placeholder='Doctor Qualification'
                                 value={dqualification}
                                 onChange={(e)=>setDqualification(e.target.value)}
                                 />
                              </div>
                            </div>

                          </div>

                              <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='whospitalw'
                                 className='form-control'
                                 placeholder='Which Hospital Working'
                                 value={whospitalw}
                                 onChange={(e)=>setWhospitalw(e.target.value)}
                                 />
                              </div>
                            </div>

                             <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='location'
                                 className='form-control'
                                 placeholder='Location'
                                 value={location}
                                 onChange={(e)=>setLocation(e.target.value)}
                                 />
                              </div>
                            </div>
                          </div>





                          


                              <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>
                               <input type='text' 
                                name='dphone'
                                 className='form-control'
                                 placeholder='Doctor Phone Number'
                                 value={dphone}
                                 onChange={(e)=>setDphone(e.target.value)}
                                 />
                              </div>
                                 <input type='submit'
                                 value='Book Doctor'
                                 className='btn btn-success'
                                 />

                            </div>
                          </div>
                        </form>
                        </div>

                      </div>
                    </div>
                   </section>

                   </main>

       
    )
}

export default AddDoctor
